import Modal from '@mui/material/Modal';
import React from 'react';
import { getFormattedPrice } from '../../helpers/price';
import Button from '../core/Button';
import styles from './AcceptOfferModal.module.scss';

export interface Props {
  open: boolean;
  property: any;
  offer: any;
  onClose: () => void;
  onSubmit: () => void;
}

export default function AcceptOfferModal(props: Props) {
  return (
    <Modal
      open={props.open}
      className={styles.container}
      onClose={props.onClose}
    >
      <div className={styles.content}>
        <h1>Aceptar Oferta</h1>
        <p>
          Estás seguro de aceptar la oferta de la propiedad por un precio final
          de
          <b>{getFormattedPrice(props.offer?.offer, { prefix: ' ' })}</b>?
        </p>

        <form>
          <Button label="ACEPTAR" onClick={() => props.onSubmit()} />
        </form>
      </div>
    </Modal>
  );
}
